import getRootServerUrl from '@/src/app/utils/getRootServerUrl';
import {coAuthorProps} from '@/src/coAuthors/components/CoAuthorsList';
import {Text} from '@/src/ui';

import Avatar from '../../ui/avatar/components/Avatar';
import css from '../styles/CoAuthorsList.module.css';

interface CoAuthorsListItemProps {
  coAuthor: coAuthorProps;
}

const CoAuthorsListItem = ({coAuthor}: CoAuthorsListItemProps) => {
  return (
    <div className={css.item}>
      <Avatar
        size={'small'}
        picture={
          coAuthor.picture ? `${getRootServerUrl()}${coAuthor.picture}` : null
        }
        organizationName={coAuthor.name}
      />
      <Text
        isOneLine
        fontSize={Text.FONT_SIZE.SIZE_16}
        fontWeight={Text.FONT_WEIGHT.MEDIUM}
      >
        {coAuthor.name}
      </Text>
    </div>
  );
};

export default CoAuthorsListItem;
